import { Tween } from "@westpierstudio/luma/createjs";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Graphics, Sprite } from "pixi.js";
import { Signal } from "type-signals";

class BonusTransitionPanelSignals {
    panelMoveInComplete = new Signal();
    panelSequenceComplete = new Signal();
}

export class BonusTransitionPanels extends View {
    private readonly panels: Sprite[] = [];
    private readonly offsetYPos: number[] = [];
    signals = new BonusTransitionPanelSignals();

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, resources} = this.services;

        const spec = resources.getSpec(`bonustransitionpanels`);
        factory.applySpec(this, spec);

        let sprite;

        for (const childName of Object.keys(spec.slices)) {

            sprite = factory.createSprite(spec.slices[childName], this);
            this.panels.push(sprite);
        }

        this.setupMask();

        let offset;
        const panelHeigth = this.height;

        for (const [i, sprite] of this.panels.entries()) {

            offset = ((i % 2) === 0) ? -panelHeigth : panelHeigth;
            sprite.y = offset;
            this.offsetYPos.push(offset);
        }

       this.visible = false;
    }

    private setupMask(): void {

        const width = this.width;
        const height = this.height;

        const graphic = new Graphics();

        graphic.beginFill(0xFFFFFF);
        graphic.drawRect(0, 0, width, height);
        graphic.endFill();

        this.addChild(graphic);
        this.mask = graphic;
    }

    playTransition(): void {

        this.visible = true;

        const settings = this.services.resources.getSetting(`bonusTransition`);

        for (const [i, sprite] of this.panels.entries()) {

            const tween = Tween.get(sprite);
            tween.to({y: 0}, settings.moveTime);

            if (i === this.panels.length-1) {

                tween.call(() => {
                    this.signals.panelMoveInComplete.dispatch();
                });
            }

            tween.wait(settings.holdTime);
            tween.to({y: this.offsetYPos[i]}, settings.moveTime);

            if (i === this.panels.length-1) {

                tween.call(() => {
                    this.visible = false;
                    this.signals.panelSequenceComplete.dispatch();
                });
            }
        }
    }

    playOpen() {
        this.visible = true;
        const settings = this.services.resources.getSetting(`bonusTransition`);
        for (const [i, sprite] of this.panels.entries()) {
            const tween = Tween.get(sprite).to({y: this.offsetYPos[i]}, settings.moveTime);
            if (i === this.panels.length-1) {
                tween.call(() => {
                    this.visible = false;
                    this.signals.panelSequenceComplete.dispatch();
                });
            }
        }
    }

    playClosed() {
        this.visible = true;
        const settings = this.services.resources.getSetting(`bonusTransition`);
        for (const [i, sprite] of this.panels.entries()) {
            const tween = Tween.get(sprite).to({y: 0}, settings.moveTime);;
            if (i === this.panels.length-1) {
                tween.call(() => {
                    this.signals.panelMoveInComplete.dispatch();
                });
            }
        }
    }

    setClosed() {
        this.visible = true;
        for (const [i, sprite] of this.panels.entries()) {
            sprite.y = 0;
        }
    }

    override reset(): void {

        for (const [i, sprite] of this.panels.entries()) {

            Tween.removeTweens(sprite);
            sprite.y = this.offsetYPos[i];
        }

        this.visible = false;
    }
}